export enum PERMISSIONS {
  PUBLIC = "PUBLIC",
  AUTHENTICATED = "AUTHENTICATED",
  BECOME_VOLUNTEER = "BECOME_VOLUNTEER",

  VIEW_MISSIONS = "VIEW_MISSIONS",
  CREATE_NEW_MISSIONS = "CREATE_NEW_MISSIONS",

  VIEW_ORGANIZER_DASHBOARD = "VIEW_ORGANIZER_DASHBOARD",
  VIEW_ALL_MISSIONS = "VIEW_ALL_MISSIONS",
  VIEW_ALL_RECIPIENTS = "VIEW_ALL_RECIPIENTS",
  VIEW_ALL_VOLUNTEERS = "VIEW_ALL_VOLUNTEERS",
}
